import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { JetAlertsProvider } from './context/JetAlertsProvider'
import { JetAlertsMain } from './components/JetAlertsMain'

export const JetAlerts = () => {
  return (
    <NuqsAdapter>
      <JetAlertsProvider>
        <JetAlertsMain />
      </JetAlertsProvider>
    </NuqsAdapter>
  )
}
